import { createApiConstants } from '@saucelabs/sl-util-redux';

export const NAMESPACE = 'user-table';

const createApiNamespacedConstants = createApiConstants.bind(null, NAMESPACE);


export const USER_CREATE = createApiNamespacedConstants('user_create');
export const INVITATION_CREATE = createApiNamespacedConstants('invitation_create');
export const TEAMLIST_GET = createApiNamespacedConstants('teamlist_get');
